import { Wallet} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const earnWalletWithdrawal = {
    id: 'earnWalletWithdrawal',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'earnWalletWithdrawal',
            title: 'Earn Wallet Withdrawal',
            type: 'item',
            url: '/earnWalletWithdrawal',
            icon: Wallet,
            breadcrumbs: false
        },
       
    ]
};

export default earnWalletWithdrawal;
